<div class="container main border">
    <div class="row">
        <!-- <div class="col-lg-12"> -->
            <div class="p-3" style="background-color:gainsboro" id="Info">
                <h4 *ngIf="showcdinfo">
                    The PowerMate<b>&reg;</b> program will guide you through the Cone Drive right angle gearbox selection process based on your NEMA motor and application criteria.
                </h4>
                <h4 *ngIf="showspinfo">
                   The PowerMate<b>&reg;</b> program will guide you through the Spinea right angle gearbox selection process based on your NEMA motor and application criteria. 
                </h4>
            </div>
        <!-- </div> -->
        
    </div>
    
    <!-- <app-registration-form></app-registration-form> -->
    
    <app-first-selection></app-first-selection>
    <app-second-selection></app-second-selection>
    <app-third-selection></app-third-selection>
    <app-fourth-selection *ngIf="Series === 'HP' || Series === 'HPNOFAN'"></app-fourth-selection>
    <app-final-page *ngIf="Series === 'HP' || Series === 'HPNOFAN'"></app-final-page>
    <app-rg-second-selection *ngIf="Series === 'RG'"></app-rg-second-selection>
    <app-rg-final-selection *ngIf="Series === 'RG'"></app-rg-final-selection>
    <app-hpa-second-selection *ngIf="Series === 'HPA'"></app-hpa-second-selection>
    <app-hpa-final-selection *ngIf="Series === 'HPA'"></app-hpa-final-selection>
    <app-hpa-second-selection *ngIf="Series === 'HPANOFAN'"></app-hpa-second-selection>
    <app-hpa-final-selection *ngIf="Series === 'HPANOFAN'"></app-hpa-final-selection>
    <app-b-second-selection *ngIf="Series === 'B'"></app-b-second-selection>
    <app-b-final-selection *ngIf="Series === 'B'"></app-b-final-selection>
    <app-f-first-selection *ngIf="Series === 'F'"></app-f-first-selection>
    <app-f-second-selection *ngIf="Series === 'F'"></app-f-second-selection>
    <app-f-final-selection *ngIf="Series === 'F'"></app-f-final-selection>
</div>
